import * as types from '../actions/types';

const initialState = {
  isError: false,
  isRefresh: false
};

const downloadBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.STORE_BANNER_FUNCTION_REQUEST:
      return {
        ...state,
        error: null
      };
    case types.STORE_BANNER_FUNCTION_SUCCEEDED:
      return {
        ...state,
        error: null
      };
    case types.STORE_BANNER_FUNCTION_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };

    case types.HIDE_ERROR:
      return {
        ...state,
        isError: false
      };
    default:
      return state;
  }
};

export default downloadBannerReducer;
